<template>
  <template v-if="serviceType === services.SERVICE_RENT">
    <VehicleOrderTemplateComponent>

      <template #order-info>
        <RentOrderInfoComponent
            :order-data="!withDriver ? store.state.orderFalseDriver : store.state.orderTrueDriver"
            :with-driver="withDriver"
        />
      </template>

      <template #vehicle-info>
        <VehicleInfoComponent :vehicle="store.state.vehicle.selectedVehicle" />
        <div class="col-sm-12 col-md-12 col-lg-11 hr-line" style="margin-top: 3.5rem"></div>
      </template>

      <template #payment-type>
        <OrderChoosePaymentComponent :payment-methods-prop="paymentMethods" />
      </template>

      <template #order-form>
        <OrderFormComponent></OrderFormComponent>
      </template>

    </VehicleOrderTemplateComponent>
  </template>

  <template v-if="serviceType === services.SERVICE_TRANSPORTATION">
    <VehicleOrderTemplateComponent>

      <template #order-info>
        <TransportationOrderInfoComponent
                :order-data="roundTrip ? trueRoundTrip : falseRoundTrip"
                :is-round-trip="roundTrip"
                :is-loading="isLoading"
        />
      </template>

      <template #payment-type>
        <OrderChoosePaymentComponent :payment-methods-prop="paymentMethods"></OrderChoosePaymentComponent>
      </template>

      <template #order-form>
        <OrderFormComponent :is-loading="isLoading"></OrderFormComponent>
      </template>

    </VehicleOrderTemplateComponent>
  </template>

</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapState, useStore} from "vuex";
import axios from "axios";
// @ts-ignore
import apiService from "../../services/apiService";
import apiDataService from "../../services/apiDataService";
import {ServiceTypes} from "../../interfaces/enums/ServiceTypes.enum";
import {routesConst} from "../../routes";
// @ts-ignore
import type {IApiResponsePaymentMethod} from "@/interfaces/apiResponseInterfaces/IApiResponsePaymentMethod.interface";
import type { IPaymentMethod } from "@/interfaces/IPaymentMethod.interface";
import type {IOrderState} from "@/store/states/IOrderState.interface";
import type { IOrderFalseRoundTripState } from "@/store/states/IOrderFalseRoundTripState.interface";
import type { IOrderTrueRoundTripState } from "@/store/states/IOrderTrueRoundTripState.interface";

// @ts-ignore
import VehicleOrderTemplateComponent from "../../components/vehicleOrderTemplate/VehicleOrderTemplateComponent.vue";
// @ts-ignore
import RentOrderInfoComponent from "../../components/vehicleOrderTemplateContainers/rentOrderInfo/RentOrderInfoComponent.vue";
// @ts-ignore
import VehicleInfoComponent from "../../components/vehicleOrderTemplateContainers/rentVehicleInfo/VehicleInfoComponent.vue";
// @ts-ignore
import OrderFormComponent from "../../components/vehicleOrderTemplateContainers/OrderForm/OrderFormComponent.vue";
// @ts-ignore
import TransportationOrderInfoComponent from '../../components/vehicleOrderTemplateContainers/transportationOrderInfo/TransportationOrderInfoComponent.vue';
// @ts-ignore
import OrderChoosePaymentComponent from '../../components/vehicleOrderTemplateContainers/orderChoosePaymentComponent/OrderChoosePaymentComponent.vue';

export default defineComponent( {
  name: 'OrderPage',
  components: {
    TransportationOrderInfoComponent,
    OrderFormComponent,
    VehicleInfoComponent,
    RentOrderInfoComponent,
    VehicleOrderTemplateComponent,
    OrderChoosePaymentComponent
  },
  props: {},

  data() {
    return {
      paymentMethods: <IPaymentMethod[]>[],
      services: ServiceTypes,
      falseRoundTrip: <IOrderFalseRoundTripState|null>null,
      isLoading: false
    }
  },
  setup() {
    const store = useStore();

    return {
      store
    };
  },

  computed: {
    ...mapState<IOrderState>('order', {
      roundTrip: (state: IOrderState) => state.roundTrip,
      serviceType: (state: IOrderState) => state.serviceType,
      withDriver: (state: IOrderState) => state.withDriver
    }),
    ...mapState<IOrderTrueRoundTripState>('orderTrueRoundTrip', {
      trueRoundTrip: (state: IOrderTrueRoundTripState) => state
    }),
    // ...mapState<IOrderFalseRoundTripState>('orderFalseRoundTrip', {
    //   falseRoundTrip: (state: IOrderFalseRoundTripState) => state
    // }),
  },

  beforeCreate() {
    // this.store.dispatch('orderTrueDriverDates/initState');

    if (! this.store.state.order.serviceType) {
      this.$router.push(routesConst.HOME);
      return;
    }
    this.store.commit('vehicle/INITIALIZE');
  },

  async created() {
      const serviceType = this.store.state.order.serviceType;
      switch (serviceType) {
          case this.services.SERVICE_TRANSPORTATION:
              if (! this.store.state.order.roundTrip) {
                    if (!this.store.state.orderFalseRoundTrip.transportations) {
                        this.isLoading = true;

                        let response = await axios.get(apiService.getSelectedTransportationEndpoint() + '?id=' + this.store.state.orderFalseRoundTrip.transportationId);

                        await this.store.dispatch('orderFalseRoundTrip/updateState', [{
                            prop: 'transportations',
                            value: response.data
                        }]);
                        this.falseRoundTrip = this.store.state.orderFalseRoundTrip;
                        this.isLoading = false;
                    } else {
                        this.falseRoundTrip = this.store.state.orderFalseRoundTrip;
                    }
              }

              break;

          case this.services.SERVICE_RENT:
              break;
      }


    axios.get(apiService.pageOrderPageEndpoint())
        .then((response) => {
          this.paymentMethods = apiDataService.preparePaymentMethods(response.data.data.paymentMethods);
        })
        .catch(error => console.error(error));
  }
})
</script>

<style>

</style>